import type { components } from "@/lib/ApiSchema"; // generated by openapi-typescript

type schemas = components["schemas"];

export enum QueryKey {
  rfq = "rfq",
  lineItems = "lineItems",
  quoteMessage = "quoteMessage",
}

export type RFQListItem = schemas["RfqListItemSchema"];

export type RFQFull = schemas["RfqFullSchema"];

export type QuoteRevision = schemas["QuoteRevisionFullSchema"];

export interface QuoteMessage {
  body: string;
}

export interface Contact {
  name: string;
  email: string;
  organization: Organization;
}

export interface Organization {
  id: number;
  name: string;
}

export type CadModelFile = schemas["CadModelFileSchema"];
export type CadNode = schemas["CadNode"];
export type CadModel = Omit<schemas["PartCadModelSchema"], "embed_url">;

export type RFQ = schemas["RfqDetailSchema"];
export type UpdatePart = schemas["RequestedPartCreateSchemaPatch"];

export type EmailReceivedEvent = schemas["EmailReceivedEventSchema"];
export type EmailSentEvent = schemas["EmailSentEventSchema"];
export type RFQCreatedEvent = schemas["RFQCreatedEventSchema"];
export type QuoteRevisionCreatedEvent =
  schemas["QuoteRevisionCreatedEventSchema"];
export type NoteCreatedEvent = schemas["NoteCreatedEventSchema"];

export type Timeline =
  | EmailReceivedEvent
  | EmailSentEvent
  | RFQCreatedEvent
  | QuoteRevisionCreatedEvent
  | NoteCreatedEvent;

export interface Contact {
  name: string;
  email: string;
}

export interface Message {
  from: Contact;
  to: Contact[];
  cc: Contact[];
  subject: string;
  body: string;
  message_id: string;
}

export type RequestedPartDetail = schemas["RequestedPartDetailSchema"];

export interface LineItem {
  id: string;
  lead_time: string;
  unit_price: number;
  quantity: number;
  part_revision: {
    id: string;
    part_number: string;
    revision_number: string;
  };
}

export type File = schemas["FileSchema"];
